import React, { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import UsersService from '../../services/UsersService';
import AppSidebar from '../../components/AppSidebar';
import AppHeader from '../../components/AppHeader';
import PageHeader from '../../components/PageHeader';
import { toast } from 'react-toastify';

const ViewUser = () => {
    const { id } = useParams();
    const [user, setUser] = useState(null);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await UsersService.get(id);
                if (response.status === 200) {
                    setUser(response?.data?.data);
                }
            } catch (error) {
                console.error('Error fetching user:', error);
                toast.error('Failed to load user data.');
            }
        };
        fetchUser();
    }, [id]);

    if (!user) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <PageHeader
                        title="User Details"
                        button_label1="Back"
                        link_to1="/user"
                        className1="btn btn-primary btn-sm"
                    />
                    <div className="card p-4">
                        <div className="d-flex justify-content-end mb-3">
                            <NavLink to={`/user/${id}/edit`} className="btn btn-primary btn-sm">
                                Edit
                            </NavLink>
                        </div>
                        <h4 className="mb-3">User Information</h4>
                        <div className="row">
                            <div className="col-md-6">
                                <p><strong>Name:</strong> {user.name}</p>
                                <p><strong>Email:</strong> {user.email}</p>
                                <p><strong>Phone:</strong> {user.phone}</p>
                                <p><strong>Department:</strong> {user.department?.name || 'N/A'}</p>

                            </div>
                            <div className="col-md-6">
                                <p><strong>Company:</strong> {user.company?.name || 'N/A'}</p>
                                <p><strong>Role:</strong> {user.roles?.length ? user.roles.map(role => role.label).join(', ') : 'N/A'}</p>
                                <p><strong>Status:</strong> {user.status}</p>
                                <p><strong>Designation:</strong> {user?.designation?.name || 'N/A'}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default ViewUser;
